/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PaymentsSummaryRow,
    PaymentsSummaryRowFromJSON,
    PaymentsSummaryRowFromJSONTyped,
    PaymentsSummaryRowToJSON,
} from './';

/**
 * 請求金額リスト
 * @export
 * @interface PaymentsSummaryList
 */
export interface PaymentsSummaryList {
    /**
     * 
     * @type {Array<PaymentsSummaryRow>}
     * @memberof PaymentsSummaryList
     */
    payments?: Array<PaymentsSummaryRow>;
}

export function PaymentsSummaryListFromJSON(json: any): PaymentsSummaryList {
    return PaymentsSummaryListFromJSONTyped(json, false);
}

export function PaymentsSummaryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentsSummaryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payments': !exists(json, 'payments') ? undefined : ((json['payments'] as Array<any>).map(PaymentsSummaryRowFromJSON)),
    };
}

export function PaymentsSummaryListToJSON(value?: PaymentsSummaryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payments': value.payments === undefined ? undefined : ((value.payments as Array<any>).map(PaymentsSummaryRowToJSON)),
    };
}


